<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField
    :label="t('site.f.common.image_label', 'Image')"
    :help="t('site.f.image.required_upload_a_file_or_paste_an_image_help', 'Required — upload a file or paste an image URL.')"
    :error="!block.data.url ? t('site.f.image.err_image', 'This block needs an image before the page can be saved.') : undefined"
  >
    <SiteEditorImagePicker
      variant="field"
      :model-value="block.data.url"
      @update:model-value="block.data.url = $event"
    />
  </UFormField>
  <UFormField :label="t('site.f.common.alt_text_label', 'Alt text')">
    <UInput
      v-model="block.data.alt"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.common.caption_label', 'Caption')">
    <UInput
      v-model="block.data.caption"
      class="w-full"
    />
  </UFormField>
</template>
